import React from 'react';

function WhatsAppButton() {
  const phoneNumber = '6281234567890'; // Ganti dengan nomor WA tujuan
  const message = encodeURIComponent('Halo, saya tertarik dengan layanan Anda!');
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
      <button style={{ padding: '10px', backgroundColor: 'green', color: 'white', borderRadius: '5px' }}>
        Chat via WhatsApp
      </button>
    </a>
  );
}

export default WhatsAppButton;
